import CharacterAttributes from "../Character/CharacterAttributes";
import CharacterStorage from "../Storage/CharacterStorage";
import SkillRegistry from "../Skills/SkillRegistry";
import SkillManager from "../Skills/SkillManager";
import { ISkill } from "../Skills/ISkill";

export default class SkillAllocationGUI {
  private mCharAttribs: CharacterAttributes;
  private mCharStorage: CharacterStorage;
  private mSkillManager: SkillManager;
  private mAvailablePointsText: Phaser.GameObjects.Text;

  constructor(
    charAttribs: CharacterAttributes,
    skillManager: SkillManager,
    charStorage: CharacterStorage
  ) {
    this.mCharAttribs = charAttribs;
    this.mSkillManager = skillManager;
    this.mCharStorage = charStorage;
  }

  public preload(scene: Phaser.Scene): void {
    SkillRegistry.PreloadAllIcons(scene);
  }

  public create(
    scene: Phaser.Scene,
    topPosX: number,
    topPosY: number
  ): void {
    this.mAvailablePointsText = scene.add.text(
      topPosX,
      topPosY,
      `Skill Points: ${this.mCharAttribs.AvailableSkillPoints}`,
      { fontFamily: "monospace", fontSize: "32px", color: "#000000" }
    );

    const allSkills = SkillRegistry.GetAllSkills();
    let currentY = topPosY + 45;

    for (const skill of allSkills) {
      let currentLevel = this.mSkillManager.GetSkillLevel(skill.Name);
      this.createSkillRow(scene, skill, currentLevel, topPosX, currentY);
      currentY += 50;
    }
  }

  private createSkillRow(
    scene: Phaser.Scene,
    skill: ISkill,
    currentLevel: number,
    x: number,
    y: number
  ): void {
    const text = scene.add
      .text(x, y, `${skill.Name}: ${currentLevel}/${skill.MaxLevel}`, {
        fontFamily: "monospace",
        fontSize: "22px",
        color: "#000000",
      })
      .setOrigin(0, 0.5);

    const descText = scene.add
      .text(x, y + 18, skill.Description, {
        fontFamily: "monospace",
        fontSize: "14px",
        color: "#555555",
      })
      .setOrigin(0, 0.5);

    const plusBtn = scene.add
      .image(x + 400, y, "plus_button")
      .setScale(1)
      .setInteractive({ useHandCursor: true });

    plusBtn.on("pointerdown", () => {
      const allocated = this.mSkillManager.AllocatePoint(
        skill.Name,
        this.mCharAttribs,
        this.mCharStorage
      );
      if (!allocated) return;

      currentLevel++;
      text.setText(`${skill.Name}: ${currentLevel}/${skill.MaxLevel}`);
      this.mAvailablePointsText.setText(
        `Skill Points: ${this.mCharAttribs.AvailableSkillPoints}`
      );
    });
  }
}
